<script>

export default {
  props: ['item', 'admin'],
  data() {
    return {
      loading: false,
      loading_edits: false,

      uploading: false,
      showProgress: 0,
      sizelimit: 10,
      maxPhotos: 50,
      imageerrors: [],
    }
  },
  created() {
    if(!this.item.images) { this.item.images = []; }
  },
  methods: {
    addPhoto(event) {
      var $this = this;
      this.uploading = true;
      var count = 0, toadd = event.target.files.length, total = this.item.images.length, files = [];
      this.imageerrors = [];

      Array.prototype.push.apply(files, event.target.files);

      var i = files.length;
      while(i--) {
        if(files[i].size > ((1024 * 1024) * this.sizelimit)){
          this.imageerrors.push(files[i].name+' is to large. Photos cannot exceed '+this.sizelimit+'mb.');
          files.splice(i, 1);
        } else {
          for(var j = 0; j < this.item.images.length; j++){ if(this.item.images[j].name == files[i].name) {
            this.imageerrors.push('The photo '+files[i].name+' already exists.');
            files.splice(i, 1);
            break;
          } }
        }
      }

      toadd = files.length;

      if(total+1 > this.maxPhotos && !this.admin) {
        this.imageerrors.push('You have already reached the maximum of '+this.maxPhotos+' photos. Please remove any unwanted photos before adding more.');
        this.uploading = false;
        return;
      }
      if(toadd > 20) {
        toadd = 20;
        this.imageerrors.push('There is a 20 photo per upload limit. Please upload the additional photos once this upload is complete.');
      }
      if((toadd + total) > this.maxPhotos && !this.admin) {
        toadd = ((toadd) - (toadd + total - this.maxPhotos));
        this.imageerrors.push('The selected photos exceed the maximum of '+this.maxPhotos+' photos.');
      }

      if(toadd < 1){
        this.$noty.success('0 photo(s) added');
        this.uploading = false;
        return;
      }

      const fd = new FormData();
      fd.append("id", this.item.id);
      for(var i = 0; i < files.length; i++){ if(i > 19 || total > 49){ continue; } count++; total++; fd.append('file[' + i + ']', files[i]); }

      this.$http.post((this.admin ? '/api' : '') + '/listings/addimage', fd, {onUploadProgress(e) {
        const totalLength = e.lengthComputable ? e.total : e.target.getResponseHeader('content-length') || e.target.getResponseHeader('x-decompressed-content-length');
        if(totalLength !== null) {
          $this.showProgress = Math.round( (e.loaded * 100) / totalLength );
        }
      }}).then(res => {
        // console.log(res);
        if(toadd != files.length || files.length != event.target.files.length) {
          this.$noty.success(toadd+' of the '+event.target.files.length+' photo(s) added.');
        } else {
          this.$noty.success(count+' photo(s) added');
        }
        this.uploading = false;
        if(res.data.images) { this.item.images = res.data.images; }
        if(res.data.thumbnail) { this.item.thumbnail = res.data.thumbnail; }
      }).catch(res => {
        this.uploading = false;
        // this.popupErrors(res);
        this.$noty.warning('Failed to add image(s)');
      });
    },
    updateImageOrder() {
      this.loading_edits = true;
      // console.log(this.images);
      this.$http.put((this.admin ? '/api' : '') + '/listings/sortimages', {id:this.item.id, images:this.item.images}).then(res => {
        // console.log(res);
        if(res.data.images) { this.item.images = res.data.images; }
        if(res.data.thumbnail) { this.item.thumbnail = res.data.thumbnail; }
        this.loading_edits = false;
      }).catch(res => { this.popupErrors(res); this.loading_edits = false; });
    },
    deleteImage(name) {
      this.loading_edits = true;
      this.$http.post((this.admin ? '/api' : '') + '/listings/deleteimage', {id:this.item.id, name:name}).then(res => {
        // console.log(res);
        if(res.data.images) { this.item.images = res.data.images; }
        if(res.data.thumbnail) { this.item.thumbnail = res.data.thumbnail; }
        this.$noty.success(name+' removed');
        this.loading_edits = false;
      }).catch(res => { this.$noty.warning('Failed to delete image: '+name); this.loading_edits = false; });
    },
    leftPad(n, padding=2) {
      while(n.toString().length < padding) { n = '0'+n; }
      return n;
    },
    view_image(image) {
      window.open(this.storage_url+image.location, '', 'width=640,height=480');
    },
    copyThis(image) {
      const el = document.createElement('textarea');
      el.value = this.storage_url+image;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if(selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.$noty.success('Copied to clipboard');
    },
    submit_form() {
      if(this.admin){ return; }
      if(this.loading == true) { console.log("disabled"); return; } this.loading = true;
      var da_message = 'Are you sure you have finished adding photos? Once submitted, you will have to request access to make changes.';
      var btn_clicked = false;
      var n = this.$noty.success(da_message, { timeout: false, modal: true, type: 'default', layout: 'center', closeWith: ['button'],
        buttons: [
          Noty.button('YES', 'btn btn-block btn-success', res2 => {
            if(btn_clicked == true) { console.log("disabled"); return; } btn_clicked = true;
            $('#button1').text('Processing...').removeClass('btn-success').addClass('btn-light');
            this.$http.put('/listings/update-photos', {id: this.item.id}).then(res => {
              // console.log(res);
              if(res.data && res.data.StandardStatus) { this.item.StandardStatus = res.data.StandardStatus; }
              if(res.data && res.data.updated_at) { this.item.updated_at = res.data.updated_at; }
              $('#button1').text('Complete').removeClass('btn-light').addClass('btn-success');
              this.$emit('curpage');
              btn_clicked = false;
              this.loading = false;
              n.close();
            }).catch(res => {
              $('#button1').text('YES').removeClass('btn-light').addClass('btn-success');
              this.popupErrors(res);
              btn_clicked = false;
              this.loading = false;
            });
          }, {id: 'button1', 'data-status': 'ok'}),
        ]
      }).on('onClose', () => { btn_clicked = false; this.loading = false; });
    },
  }
}
</script>

<template>

  <div class="" :class="admin ? 'mt-3' : '_w-m-1000 mx-auto my-5'">
    <form @submit.prevent="submit_form()">
      <div v-if="admin" class="mb-4">
        <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> Photo Uploader :</h5>
        <p class="text-muted small">Click the add photos button to get started. If you have any trouble using the photo uploader you may also send your photos via email to <strong>{{app_email}}</strong> and skip this step.</p>
      </div>
      <div v-else class="text-center mb-4">
        <img :src="formatImage('/fm/revinre-nc/clip art/Professional Photography.png')" class="_w-m-400" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Photo uploader</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Click the add photos button to get started. If you have any trouble using the photo uploader you may also send your photos via email to <strong>{{app_email}}</strong> and skip this step.</p>
      </div>
      <div class="alert alert-info">
        <strong>Tips:</strong>
        <ul class="m-0 small">
          <li>Be sure to upload high-resolution photos.</li>
          <li>Keep your photos bright and clear.</li>
          <li>Click and drag to rearrange the images.</li>
          <li>Get a good front photo. This will be used as the primary photo.</li>
          <li>Photo file size must be under {{sizelimit}}mb each.</li>
          <li v-if="maxPhotos > 20">There is a maximum of 20 photos per upload.</li>
          <li>There is a maximum of {{maxPhotos}} photos total.</li>
        </ul>
      </div>

      <div v-if="!uploading" class="mt-4">
        <button type="button" @click="$refs.fileInput.click()" class="btn btn-lg btn-block btn-success">ADD PHOTO(S)</button>
        <input class="d-none" ref="fileInput" type="file" @change="addPhoto" accept="image/*" multiple>
      </div>
      <div v-else class="progress _h-40 mt-4">
        <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary font-weight-bold" :style="'width:'+showProgress+'%'">UPLOADING {{showProgress}}%</div>
      </div>

      <div v-if="imageerrors.length" class="mt-4">
        <div v-for="(error, index) in imageerrors" :key="index" class="alert alert-warning">
          <Icon icon="ri:close-fill" height="24" class="mt-0 float-right _c-pointer" @click="imageerrors.splice(index, 1)" />{{error}}
        </div>
      </div>

      <div class="p-1 border rounded _b-s-6 _b-dashed mt-4">
        <div v-if="item.images.length == 0" class="text-center text-muted py-4 mt-2 font-weight-bold">NO PHOTOS FOUND</div>
        <draggable v-model="item.images" :options="{animation:200}" :element="'div'" @change="updateImageOrder">
          <transition-group class="row m-0" name="fade" tag="div">
            <div class="col-6 col-md-4 col-lg-3 p-2" v-for="(image, image_i) in item.images" :key="'img-'+image_i">
              <div class="border border-light m-0 small border-hover-primary _transition-2" v-tippy content="Drag to move">
                <div class="_p-t-65p position-relative _c-pointer" @dblclick="view_image(image)" :style="'background-image: url('+formatImage('/fm/revinre-nc/trasnparent-bg.png')+')'">
                  <div class="position-absolute _pos-t-0 _pos-r-0 _pos-b-0 _pos-l-0 text-center">
                    <img class="_h-m-100p _w-m-100p" :src="formatImage(image.location)" >
                  </div>
                </div>
                <div class="card-body p-0 border-top border-light">
                  <div class="d-flex _h-30">
                    <div class="mr-auto text-truncate small">
                      <ul class="list-inline m-0 small">
                        <li class="list-inline-item p-2 m-0 _h-30 _lh-12" v-tippy content="Display order">{{leftPad(image_i+1)}}</li>
                        <li class="list-inline-item border-left border-light p-2 _h-30 _lh-12" v-tippy content="File name">{{image.name}}</li>
                      </ul>
                    </div>
                    <div class="border-left border-light dropdown">
                      <button type="button" class="btn btn-sm btn-white border-0 p-2 _lh-12" data-toggle="dropdown"><Icon icon="ri:more-2-fill" /></button>
                      <div class="dropdown-menu">
                        <a class="dropdown-item _c-pointer" @click="view_image(image)">View</a>
                        <a class="dropdown-item _c-pointer" @click="copyThis(image.location)">Copy URL</a>
                        <a class="dropdown-item _c-pointer" @click.stop.prevent="deleteImage(image.name)">Delete</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body p-0 border-top ">
                  <b-form-textarea :disabled="loading_edits" class="form-control border-0" :class="!image.caption || (image.caption && image.caption.length < 18 && !image.caption.includes('\n')) ? 'short-textarea' : ''" v-model="image.caption" placeholder="Caption..." maxlength="80" max-rows="4" @change="updateImageOrder" v-tippy content="Enter an image caption which will be entered into the MLS when applicable (Example: Master bathroom)."></b-form-textarea>
                </div>
              </div>
            </div>
        </transition-group>
        </draggable>
      </div>

      <div v-if="item.images.length" class="text-muted mt-2 small"><span class="spinner-border spinner-border-sm" v-show="loading_edits"></span> {{item.images.length}} photos attached</div>

      <div v-if="!admin" class="row py-5">
        <div class="col-6">
          <button type="button" class="btn btn-lg btn-success" @click="$emit('setpage', 8 + (item.mls.form_fields ? item.mls.form_fields.length : 0))"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">
          <button type="button" class="btn btn-lg btn-success" @click="submit_form()"><span class="spinner-border spinner-border-sm" v-show="loading"></span> Submit <Icon icon="ri:arrow-right-double-fill" /></button>
        </div>
      </div>
    </form>
  </div>

</template>
